import { Button, Space } from "antd";
import React from "react";
import ContentRow from "./ContentRow";
import { ClockIcon, EditBtnIcon, EditIcon, EyeIcon, TrashIcon, EyeSlashIcon } from "../../admin/Icons";
import { grey_color, orange_color } from "../../utils/Utils";

export default function GlobalContent(props) {

    const { selected = false, setSelected = () => { } } = props;

    return (
        <div className="float-flex" style={{ "justifyContent": "start" }}>
            <div style={{ "width": "10px" }}>&nbsp;</div>
            <div style={{ "width": "100%" }}>
                <div className="float-flex">
                    <div>Top Search Bar</div>
                    <EditIcon onClick={() => setSelected("search_bar")}style={{ "color": orange_color, "cursor" : "pointer" }} />
                </div><div className="shim" /><div className="shim" />

                <div className="float-flex">
                    <div>Navigation Bar</div>
                    <EditIcon onClick={() => setSelected("nav_bar")}style={{ "color": orange_color, "cursor" : "pointer" }} />
                </div><div className="shim" /><div className="shim" />

                <div className="float-flex">
                    <div>Footer</div>
                    <EditIcon onClick={() => setSelected("footer_bar")}style={{ "color": orange_color, "cursor" : "pointer" }} />
                </div><div className="shim" /><div className="shim" />
            </div>
            <div style={{ "width": "8px" }}>&nbsp;</div>
        </div>
    )

}